import type { Dispatch, SetStateAction } from 'react';
import type { Gallery } from '../../../../../types/reviews';
import { CONSTANTS } from './constants';

export interface CalculateDisplayCounterParams {
	element: HTMLDivElement | null;
	gallery: Gallery[];
	isDesktop: boolean;
	setAdditionalImageCount: Dispatch<SetStateAction<number>>;
	setViewableImages: Dispatch<SetStateAction<number>>;
}

export const calculateDisplayCounter = ({
	element,
	gallery,
	isDesktop,
	setAdditionalImageCount,
	setViewableImages,
}: CalculateDisplayCounterParams) => {
	if (element) {
		const numberOfImages = gallery.length;

		if (isDesktop) {
			const numberOfViewableImages = Math.floor(
				element.clientWidth /
					(CONSTANTS.desktop.imageWidth + CONSTANTS.imageMargin),
			);
			const displayCounter = numberOfImages - numberOfViewableImages + 1;

			setViewableImages(numberOfViewableImages);
			setAdditionalImageCount(displayCounter);
		} else {
			const displayCounter = numberOfImages - CONSTANTS.mobileImagesToShow + 1;

			setViewableImages(CONSTANTS.mobileImagesToShow);
			setAdditionalImageCount(displayCounter);
		}
	}
};
